if (!customElements.get('logos-marquee')) {
  class LogosMarquee extends HTMLElement {
    connectedCallback() {
      this.setupMarqueeSpeed = this.setupMarqueeSpeed.bind(this);
      this.setupMarqueeSpeed();
    }

    setupMarqueeSpeed() {
      const marqueeWidth = this.querySelector('[data-logo-marquee-items]').offsetWidth / 50;
      this.style.setProperty('--marqueeSpeed', marqueeWidth);
    }
  }

  customElements.define('logos-marquee', LogosMarquee);
}
